export default __webpack_public_path__ + "static/media/debate_28.b4d3ba53.JPG";